import { ApolloLink } from './ApolloLink.js';

export const from = ApolloLink.from;
